import { Nullable } from "@kamae-apps/shared/Types/Nullable"
import { Answer, QUESTION_TYPE } from "./Challenge"

export enum SPECIAL_EVENT_SEASON {
  WINTER = "WINTER",
  SPRING = "SPRING",
  SUMMER = "SUMMER",
  AUTUMN = "AUTUMN",
}

export enum SPECIAL_EVENT_STATE {
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
}

export enum SPECIAL_EVENT_USER_STATE {
  TODO = "TODO",
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
}

export enum SPECIAL_EVENT_TEXT_COLOR {
  DARK = "dark",
  LIGHT = "light",
}

export const CURRENT_SPECIAL_EVENT_SEASON = SPECIAL_EVENT_SEASON.SUMMER

export type SpecialEventUserParticipation = {
  rank: number
  score: number
  timer: number
  goodAnswerAmount: number
  wrongAnswerAmount: number
}

export type SpecialEventGauges = Record<string, number>

export type SpecialEventQuestion = {
  id: number
  index: number
  type: QUESTION_TYPE
  value: string
  image: Nullable<string>
  difficulty: number
  answers: Answer[]
  isCorrect?: boolean
  gauges?: SpecialEventGauges
}

export type SpecialEvent = {
  id: number
  daysLeft: number
  maxScore: number
  name: string
  headline: string
  description: string
  color: string
  url: string
  state: SPECIAL_EVENT_STATE
  userParticipation?: SpecialEventUserParticipation
  topParticipants: SpecialEventParticipant[]
  totalParticipants: number
  questions?: SpecialEventQuestion[]
  userEventState: SPECIAL_EVENT_USER_STATE
}

export type SpecialEventEndPresenter = {
  score: number
  bonusScore: number
  timer: number
  totalQuestions: number
  answeredQuestions: number
  gauges: SpecialEventGauges
}

export type SpecialEventIntroPresenter = {
  totalQuestions: number
  answeredQuestions: number
  timer: number
  userEventState: SPECIAL_EVENT_USER_STATE
  gauges: SpecialEventGauges
}

export type SpecialEventParticipant = {
  id: number
  rank: number
  firstName: string
  lastName: string
  avatar: string
  score: number
  timeSpentInSeconds: number
}

export type UserRespondSpecialEventQuestionPresenter = {
  specialEventId: number
  questionId: number
  selectedAnswerIds: number[]
}
